class CustomMegaMenu extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.pillarItems = this.querySelectorAll('[data-pillar-target]');
    this.pillarItems.forEach(item => {
      item.addEventListener('pointerenter', () => this.setActivePillar(item));
      item.addEventListener('focusin', () => this.setActivePillar(item));
    });

    // Initialize first active panel display
    const activePillar = this.getAttribute('data-active-pillar') || 'strategy-growth';
    this.updatePanels(activePillar);
  }

  setActivePillar(item) {
    const pillarTarget = item.getAttribute('data-pillar-target');
    if (pillarTarget) {
      this.setAttribute('data-active-pillar', pillarTarget);
      this.updatePanels(pillarTarget);
    }
  }

  updatePanels(activeTarget) {
    const panels = this.querySelectorAll('[data-pillar-panel]');
    panels.forEach(panel => {
      if (panel.getAttribute('data-pillar-panel') === activeTarget) {
        panel.style.display = 'flex';
      } else {
        panel.style.display = 'none';
      }
    });
  }
}

class CustomMegaMenuDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));

    // Mobile Header Back button (Level 3 -> Level 2) - Located outside this component
    const headerDrawerForBack = this.closest('header-drawer');
    if (headerDrawerForBack) {
      const mobileHeaderBackBtn = headerDrawerForBack.querySelector('.drawer-back-to-solutions');
      if (mobileHeaderBackBtn && !mobileHeaderBackBtn.hasAttribute('data-initialized')) {
        mobileHeaderBackBtn.setAttribute('data-initialized', 'true');
        mobileHeaderBackBtn.addEventListener('click', (e) => {
          e.preventDefault();
          // Desktop uses this as a global "Close" button. Mobile uses it as a "Back" button.
          if (window.innerWidth >= 990) {
            this.closeDrawer();
          } else {
            this.closePillar();
          }
        });
      }

      // Reset drawer state when the drawer is closed externally (e.g. Escape key, overlay click)
      const details = headerDrawerForBack.querySelector('details');
      if (details) {
        details.addEventListener('toggle', () => {
          if (!details.open) {
            this.resetDrawerState();
          }
        });
      }
    }
  }

  handleClick(e) {
    // 1. Level 1 -> Level 2: Trigger Solutions Mobile Panel
    const solutionsBtn = e.target.closest('[id*="HeaderDrawer-solution"]');
    if (solutionsBtn && this.contains(solutionsBtn)) {
      e.preventDefault();
      e.stopPropagation();
      this.openSolutions();
      return;
    }

    // 2. Level 2 -> Level 3: Trigger Pillar Subpanels
    const pillarBtn = e.target.closest('[data-pillar-target]');
    if (pillarBtn && this.contains(pillarBtn)) {
      e.preventDefault();
      e.stopPropagation();
      const pillarTarget = pillarBtn.getAttribute('data-pillar-target');
      this.openPillar(pillarTarget);
      return;
    }

    // 3. Back buttons (Level 2 -> Level 1)
    const backToNavBtn = e.target.closest('.custom-mega-menu-drawer__solutions-panel .custom-mega-menu-drawer__back-btn');
    if (backToNavBtn && this.contains(backToNavBtn)) {
      e.preventDefault();
      e.stopPropagation();
      this.closeSolutions();
      return;
    }

    // 4. Back buttons (Level 3 -> Level 2)
    const backToSolutionsBtn = e.target.closest('.custom-mega-menu-drawer__pillar-panel .custom-mega-menu-drawer__back-btn');
    if (backToSolutionsBtn && this.contains(backToSolutionsBtn)) {
      e.preventDefault();
      e.stopPropagation();
      this.closePillar();
      return;
    }

    // 5. Drawer Close Buttons (close entire drawer)
    const closeBtn = e.target.closest('.custom-mega-menu-drawer__close-btn');
    if (closeBtn && this.contains(closeBtn)) {
      e.preventDefault();
      this.closeDrawer();
      return;
    }
  }

  openSolutions() {
    this.setAttribute('data-active-view', 'solutions');
  }

  closeSolutions() {
    this.removeAttribute('data-active-view');
  }

  openPillar(pillarTarget) {
    this.setAttribute('data-active-view', 'pillar');
    const headerDrawer = this.closest('header-drawer');
    if (headerDrawer) headerDrawer.classList.add('drawer-view-pillar');
    
    // Deactivate all panels
    const panels = this.querySelectorAll('[data-pillar-panel]');
    panels.forEach(panel => {
      if (panel.getAttribute('data-pillar-panel') === pillarTarget) {
        panel.classList.add('active');
      } else {
        panel.classList.remove('active');
      }
    });

    // Highlight active button
    const btns = this.querySelectorAll('[data-pillar-target]');
    btns.forEach(btn => {
      if (btn.getAttribute('data-pillar-target') === pillarTarget) {
        btn.classList.add('active');
      } else {
        btn.classList.remove('active');
      }
    });
  }

  closePillar() {
    this.setAttribute('data-active-view', 'solutions');
    const headerDrawer = this.closest('header-drawer');
    
    // Keep the active class momentarily for slide out transition, or remove after transition
    setTimeout(() => {
      if (this.getAttribute('data-active-view') === 'solutions') {
        const panels = this.querySelectorAll('[data-pillar-panel]');
        panels.forEach(panel => panel.classList.remove('active'));
        if (headerDrawer) headerDrawer.classList.remove('drawer-view-pillar');
      }
    }, 300);
  }

  resetDrawerState() {
    // Reset mobile views back to main list
    this.removeAttribute('data-active-view');
    const headerDrawer = this.closest('header-drawer');
    if (headerDrawer) headerDrawer.classList.remove('drawer-view-pillar');
    
    // Remove active classes from panels
    const panels = this.querySelectorAll('[data-pillar-panel]');
    panels.forEach(panel => panel.classList.remove('active'));

    // Remove active classes from pillar buttons
    if (this.pillarBtns) {
      this.pillarBtns.forEach(btn => btn.classList.remove('active'));
    }

    // Reset scroll positions to top
    const scrollableAreas = this.querySelectorAll('.custom-mega-menu-drawer__solutions-content, .custom-mega-menu-drawer__pillar-content, .menu-drawer__navigation');
    scrollableAreas.forEach(area => {
      area.scrollTop = 0;
    });
  }

  closeDrawer() {
    this.resetDrawerState();

    // Trigger normal close on parent header-drawer element
    const headerDrawer = this.closest('header-drawer');
    if (headerDrawer) {
      const details = headerDrawer.querySelector('details');
      if (details) {
        details.removeAttribute('open');
        // Reset toggle icons / body scroll-lock if managed by the theme
        const summary = details.querySelector('summary');
        if (summary) {
          summary.setAttribute('aria-expanded', 'false');
        }
        document.documentElement.classList.remove('overflow-hidden');
      }
    }
  }
}

if (!customElements.get('custom-mega-menu')) {
  customElements.define('custom-mega-menu', CustomMegaMenu);
}

if (!customElements.get('custom-mega-menu-drawer')) {
  customElements.define('custom-mega-menu-drawer', CustomMegaMenuDrawer);
}
